<template>
  <div class="historico-atendimentos">
    <h2>Histórico atendimentos </h2>
    <div class="filters">
      <div class="filter-container">
        <div class="filter-wrapper">
          <div class="filter-row">

            <!-- Data inicial -->
            <v-menu
              v-model="menuStart"
              :close-on-content-click="false"
              transition="scale-transition"
              min-width="auto"
              content-class="menu-datepicker"
              offset-y
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  label="Data inicial"
                  v-model="startDate"
                  readonly
                  append-icon="mdi-calendar"
                  
                />
              </template>
              <v-date-picker locale="pt-br" v-model="startDate" no-title scrollable />
            </v-menu>

            <!-- Data final -->
            <v-menu
              v-model="menuEnd"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              content-class="menu-datepicker"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-bind="attrs"
                  v-on="on"
                  label="Data final"
                  v-model="endDate"
                  readonly
                  append-icon="mdi-calendar"
                />
              </template>
              <v-date-picker locale="pt-br" v-model="endDate" no-title scrollable />
            </v-menu>

            <!-- Botões -->
            <v-btn text @click="getAttendancesByFilter">Filtrar</v-btn>

            <!-- Pesquisar -->
            <v-text-field 
              v-model="searchTerm" 
              label="Pesquisar" 
              prepend-icon="mdi-magnify" 
              clearable
              class="search-field"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- Dashboard KPIs -->
    <div class="dashboard-grid" v-if="kpis">
      <div class="dashboard-card card-realtime">
        <h3>Tempos</h3>
        <div class="kpi-row">
         <div class="kpi-item">
            <strong>{{ kpis.tempoMaximoFila }}</strong>
            <span>Tempo máximo na fila</span>
          </div>
          <div class="kpi-item">
            <strong>{{ kpis.mediaTicketsPorAtendente }}</strong>
            <span>Média de tickets por atendente</span>
          </div>
        </div>
      </div>

      <div class="dashboard-card card-agents">
        <h3>Status dos agentes</h3>
        <div class="kpi-row center">
          <div class="kpi-status">
            <span class="dot green"></span>
            <strong>{{ kpis.operadoresOnline }}</strong>
            <span>Online</span>
          </div>
          <div class="kpi-status">
            <span class="dot gray"></span>
            <strong>{{ kpis.operadoresInvisiveis }}</strong>
            <span>Indisponíveis</span>
          </div>
        </div>
      </div>

      <div class="dashboard-card card-today">
        <h3>Atendimento</h3>
        <div class="kpi-row">
          <div class="kpi-item">
            <strong>{{ kpis.tempoMedioEspera }}</strong>
            <span>Tempo médio de espera</span>
          </div>
          <div class="kpi-item">
            <strong>{{ kpis.tempoMedioAtendimento }}</strong>
            <span>Tempo médio de atendimento</span>
          </div>
        </div>
      </div>

      <div class="dashboard-card card-tickets">
        <h3>Status dos tickets</h3>
        <div class="kpi-row center">
          <div class="kpi-item danger">
            <strong>{{ kpis.perdidos }}</strong>
            <span>Perdidos</span>
          </div>
          <div class="kpi-item">
            <strong>{{ kpis.fechados }}</strong>
            <span>Fechados</span>
          </div>
        </div>
      </div>
    </div>

    <v-card class="mt-4">
      <v-card-title class="d-flex justify-space-between align-center">
        <span class="text-subtitle-1 font-weight-bold">
          Dados de Atendimento
        </span>
      </v-card-title>

      <!-- Abas -->
      <v-tabs v-model="activeTab" class="elevation-1">
        <!-- Aba Tickets -->
        <v-tab key="tickets">Tickets</v-tab>
        <v-tab key="agents">Atendentes</v-tab>
        <v-tab key="reasons">Motivos</v-tab>

        <!-- Conteúdo Aba Tickets -->
        <v-tab-item key="tickets">
          <div class="tab-content">
            <v-data-table
              :headers="headersServices"
              :items="filteredServicesStatus"
              item-key="attendence_Id"
              class="elevation-1"
              dense
            >
              <template v-slot:no-data>
                Nenhum atendimento encontrado para este agente.
              </template>
              <template slot="item.attendence_Queue_Start" slot-scope="{ item }">
                {{ formatDtHr(item.attendence_Queue_Start) }}
              </template>
              <template slot="item.actions" slot-scope="{ item }">
                <v-icon
                  small
                  color="green"
                  title="Ver chat"
                  @click="getFullService(item.attendence_Id)"
                >
                  mdi-chat
                </v-icon>
              </template>
            </v-data-table>
          </div>
          <v-card-actions class="justify-end">
            <v-btn small color="primary" @click="exportCsv">
              Exportar
            </v-btn>
          </v-card-actions>
        </v-tab-item>

        <!-- Conteúdo Aba Atendentes -->
        <v-tab-item key="agents">
          <div class="tab-content">
            <v-data-table
              :headers="agentCountHeaders"
              :items="agentCountItems"
              dense
              class="elevation-1"
              :items-per-page="10"
            >
              <template v-slot:no-data>
                Nenhum atendimento encontrado.
              </template>
            </v-data-table>
          </div>
          <v-card-actions class="justify-end">
            <v-btn small color="primary" @click="exportAgentCountCsv">
              Exportar
            </v-btn>
          </v-card-actions>
        </v-tab-item>

        <!-- Conteúdo Aba Motivos -->
        <v-tab-item key="reasons">
          <div class="tab-content">
            <v-data-table
              :headers="reasonHeaders"
              :items="reasonTableItems"
              dense
              class="elevation-1"
              :items-per-page="10"
            >
              <template v-slot:no-data>
                Nenhum motivo encontrado.
              </template>
            </v-data-table>
          </div>
          <v-card-actions class="justify-end">
            <v-btn small color="primary" @click="exportReasonCsv">
              Exportar
            </v-btn>
          </v-card-actions>
        </v-tab-item>
      </v-tabs>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snack = false"> {{ $t('Guid.close') }} </v-btn>
      </template>
    </v-snackbar>
    
    <v-dialog v-model="dialogInteracoes" max-width="900px">
      <v-card>
        <v-card-title>
          Histórico de Interações
          <v-spacer />
          <v-btn icon @click="dialogInteracoes = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            v-if="interacoes.length > 0"
            color="primary"
            text
            @click="forceFileDownloadDialog(interacoes, $t('PainelCliente.detailsMessage'))"
          >
            {{ $t('Guid.export') }}
          </v-btn>

          <v-btn
            color="primary"
            text
            @click="closeDialog"
          >
            {{ $t("Guid.close") }}
          </v-btn>
        </v-card-actions>
        <v-card-text>
          <v-data-table
            :headers="headersFullServices"
            :items="interacoes"
            :loading="loadingInteracoes"
            disable-pagination
            hide-default-footer
            dense
          >
            <template v-slot:no-data>
              Nenhuma interação encontrada.
            </template>

            <template slot="item.message_Update" slot-scope="{ item }">
              {{ formatDtHr(item.message_Update) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>  
</template>

<script>

import {  mapActions, mapGetters } from "vuex";
import axios from 'axios';
function todayISO() {
  const d = new Date();
  return d.toISOString().slice(0, 10);
}

export default {
  props:{
    id: {
      type: Number,
      required: false,
    },
    initialStartDate: {
      type: String,
      default: null
    },
    initialEndDate: {
      type: String,
      default: null
    },
    ticketId: {
      type: Number,
      required: false,
    }
  },
  name: "DetalheAtendimentos",
  data() {
    const today = todayISO();
    return {
      token: JSON.parse(localStorage.getItem("authUser")).token,
      menuStart: false,
      menuEnd: false,
      startDate: this.initialStartDate || today,
      endDate: this.initialEndDate || today,
      ignoreAgentFilter: false,
      attendantId: "",
      statusId: "",
      operadoresOnline: 0,
      operadoresInvisiveis: 0,
      operadoresTotal: 0,
      totalAttendence: 0,
      abandonados: 0,
      searchTerm: "",
      activeTab: 0,
      ext_opp : axios.create({
        baseURL: process.env.VUE_APP_ENV_API_ATT_EXT_OPP
    }),
      headersServices: [
        { text: 'Ticket', value: 'attendence_Id' },
        { text: 'Atendente', value: 'agent_Name' },
        { text: 'Data', value: 'attendence_Queue_Start' },
        { text: 'Contato', value: 'client_Name' },
        { text: 'Telefone Contato', value: 'client_Identify' },
        { text: 'Tempo de espera', value: 'tempoEspera' },
        { text: 'Tempo de 1º resposta', value: 'tempoPrimeiraResposta' },
        { text: 'Tempo de atendimento', value: 'tempoAtendimento'},
        { text: 'Status', value: 'status' },
        { text: 'Motivo', value: 'reason_Description'},
        { text: 'Submotivo', value: 'sub_Reason_Description'},
        { text: 'Ações', value: 'actions', sortable: false }        
      ],
      agentCountHeaders: [
        { text: 'Atendente', value: 'atendente' },
        { text: 'Finalizados', value: 'finalizados', align: 'center' },
        { text: 'Tempo Médio Espera', value: 'tempoMedioEspera', align: 'center' },
        { text: 'Tempo 1ª Resposta', value: 'tempoPrimeiraResposta', align: 'center' },
        { text: 'Tempo Médio Atendimento', value: 'tempoMedioAtendimento', align: 'center' }
      ],
      reasonHeaders: [
        { text: 'Submotivo', value: 'subMotivo' },
        { text: 'Motivo', value: 'motivo' },
        { text: 'Quantidade', value: 'quantidade', align: 'center' },
        { text: 'Tempo Médio Espera', value: 'tempoMedioEspera', align: 'center' },
        { text: 'Tempo 1ª Resposta', value: 'tempoPrimeiraResposta', align: 'center' },
        { text: 'Tempo Médio Atendimento', value: 'tempoMedioAtendimento', align: 'center' }
      ],
      telephoneArray: JSON.parse(localStorage.getItem("telephoneArray")) || [],
      snack: false,
      snackColor: "",
      snackText: "",
      historic: false,
      historicArray: [],
      conversaDados: [],
      loadingInteracoes: false,
      dialogInteracoes: false,
      interacoes: [],
      servicesStatus: [],
      agentsCalls: [],
      };
  },
  computed: {
    ...mapGetters([
      "getCurrentCustomer"      
    ]),
    
     headersFullServices(){
      return [
        {
          text: this.$t("PainelCliente.fullServicesTable.message_Update"),
          value: "message_Update",
          width: "14%",
          align: "center",
          class: "font-weight-black",
          sortable: false,
        },
        {
          text: this.$t("PainelCliente.fullServicesTable.message"),
          value: "message",
          width: "14%",
          align: "center",
          class: "font-weight-black",
          sortable: false,
        },
        {
          text: this.$t("PainelCliente.fullServicesTable.message_Direction"),
          value: "message_Direction",
          width: "14%",
          align: "center",
          class: "font-weight-black",
          sortable: false,
        }
      ]
    },
    kpis() {
      const r = this.$store.state.painelAtendimento;
      if (!r) return null;

      const mediaTicketsPorAtendente =
        this.operadoresTotal > 0
          ? (this.totalAttendence / this.operadoresTotal).toFixed(1)
          : 0;
      console.log("Painel Atendimento KPIs data:", r);
      return {
        // Atendimento em tempo real
        naFila: r.atendimentos_Em_Fila,
        tempoMaximoFila: this.formatSeconds(r.tempo_Maximo_Em_Espera_Segundos),
        emAtendimento: r.atendimentos_Em_Aberto,
        mediaTicketsPorAtendente,

        // Atendimento hoje
        tempoMedioEspera: this.formatSeconds(r.tempo_Medio_Espera_Segundos),
        tempoMedioAtendimento: this.formatSeconds(r.tempo_Medio_Em_Atendimento_Segundos),

        // Operadores
        operadoresOnline: this.operadoresOnline,
        operadoresInvisiveis: this.operadoresInvisiveis,

        // Status dos tickets
        perdidos: r.atendimentos_Perdidos,
        fechados: r.atendimentos_Fechados
      };
    },
    agentCountItems() {
      const grouped = new Map();

      this.agentsCalls.forEach(item => {
        const agentName = item.agent_Name || "Desconhecido";
        if (!grouped.has(agentName)) {
          grouped.set(agentName, {
            atendente: agentName,
            finalizados: 0,
            tempoEsperaTotal: 0,
            tempoPrimeiraRespostaTotal: 0,
            tempoAtendimentoTotal: 0,
            count: 0
          });
        }
        const group = grouped.get(agentName);
        group.finalizados += 1;
        group.tempoEsperaTotal += this.timeStringToSeconds(item.tempoEspera || "00:00:00");
        group.tempoPrimeiraRespostaTotal += this.timeStringToSeconds(item.tempoPrimeiraResposta || "00:00:00");
        group.tempoAtendimentoTotal += this.timeStringToSeconds(item.tempoAtendimento || "00:00:00");
        group.count += 1;
      });

      return Array.from(grouped.values())
        .map(item => ({
          ...item,
          tempoMedioEspera: this.formatSeconds(Math.round(item.tempoEsperaTotal / item.count)),
          tempoPrimeiraResposta: this.formatSeconds(Math.round(item.tempoPrimeiraRespostaTotal / item.count)),
          tempoMedioAtendimento: this.formatSeconds(Math.round(item.tempoAtendimentoTotal / item.count))
        }))
        .filter(item => 
          !this.searchTerm || 
          item.atendente.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
        .sort((a, b) => b.finalizados - a.finalizados);
    },
    reasonTableItems() {
      const grouped = new Map();

      this.agentsCalls.forEach(item => {
        const subMotivo = item.sub_Reason_Description;
        if (!grouped.has(subMotivo)) {
          grouped.set(subMotivo, {
            subMotivo: subMotivo,
            quantidade: 0,
            tempoEsperaTotal: 0,
            tempoPrimeiraRespostaTotal: 0,
            tempoAtendimentoTotal: 0,
            count: 0
          });
        }
        const group = grouped.get(subMotivo);
        group.motivo = item.reason_Description;
        group.quantidade += 1;
        group.tempoEsperaTotal += this.timeStringToSeconds(item.tempoEspera || "00:00:00");
        group.tempoPrimeiraRespostaTotal += this.timeStringToSeconds(item.tempoPrimeiraResposta || "00:00:00");
        group.tempoAtendimentoTotal += this.timeStringToSeconds(item.tempoAtendimento || "00:00:00");
        group.count += 1;
      });

      return Array.from(grouped.values())
        .map(item => ({
          ...item,
          tempoMedioEspera: this.formatSeconds(Math.round(item.tempoEsperaTotal / item.count)),
          tempoPrimeiraResposta: this.formatSeconds(Math.round(item.tempoPrimeiraRespostaTotal / item.count)),
          tempoMedioAtendimento: this.formatSeconds(Math.round(item.tempoAtendimentoTotal / item.count))
        }))
        .filter(item => 
          !this.searchTerm || 
          item.motivo.toLowerCase().includes(this.searchTerm.toLowerCase())
        )
        .sort((a, b) => b.quantidade - a.quantidade);
    },
    filteredServicesStatus() {
      if (!this.searchTerm) {
        return this.servicesStatus;
      }
      
      const searchLower = this.searchTerm.toLowerCase();
      return this.servicesStatus.filter(item => 
        (item.agent_Name && item.agent_Name.toLowerCase().includes(searchLower)) ||
        (item.client_Name && item.client_Name.toLowerCase().includes(searchLower)) ||
        (item.client_Identify && item.client_Identify.toLowerCase().includes(searchLower)) ||
        (item.reason_Description && item.reason_Description.toLowerCase().includes(searchLower)) ||
        (item.status && item.status.toLowerCase().includes(searchLower)) ||
        (item.attendence_Id && String(item.attendence_Id).includes(searchLower))
      );
    }
  },
  methods: {
    ...mapActions(["getDetalheAtendimento"]),
    closeDialog() {
      this.interacoes = []
      this.dialogInteracoes = false
    },
    async fetchLightDashboard() {
      const dateStart = this.startDate + "T00:00:00";
      const dateEnd = this.endDate + "T23:59:59";

      try {
        const r = await this.ext_opp.get(
          `Light_Dashboard?customer_id=${localStorage.getItem("customer_Id")}&start_date_time=${this.utcMethod(dateStart)}&end_date_time=${this.utcMethod(dateEnd)}`,
          { headers: { accept: "*/*" } }
        );

        this.operadoresOnline = r.data.number_Agents_Enable;
        this.operadoresInvisiveis = r.data.number_Agents_Disable;
        this.operadoresTotal = r.data.total_Agents;
        this.totalAttendence = r.data.total_Attendence;
        this.abandonados = 0;
        console.log("Light Dashboard data:", r.data);
      } catch (err) {
        console.error("Erro Light Dashboard", err);
      }
    },
    formatSeconds(seconds) {
      if (!seconds && seconds !== 0) return "00:00:00";

      const h = Math.floor(seconds / 3600);
      const m = Math.floor((seconds % 3600) / 60);
      const s = Math.floor(seconds % 60);

      return [h, m, s].map(v => String(v).padStart(2, "0")).join(":");
    },
    timeStringToSeconds(timeString) {
      if (!timeString) return 0;
      const parts = timeString.split(":");
      if (parts.length !== 3) return 0;
      const hours = parseInt(parts[0], 10) || 0;
      const minutes = parseInt(parts[1], 10) || 0;
      const seconds = parseInt(parts[2], 10) || 0;
      return hours * 3600 + minutes * 60 + seconds;
    },
    exportAgentCountCsv() {
      if (!this.agentCountItems.length) {
        return;
      }

      const headers = [
        "Atendente",
        "Finalizados",
        "Tempo Médio Espera",
        "Tempo 1ª Resposta",
        "Tempo Médio Atendimento"
      ];

      const rows = this.agentCountItems.map(item => [
        item.atendente,
        item.finalizados,
        item.tempoMedioEspera,
        item.tempoPrimeiraResposta,
        item.tempoMedioAtendimento
      ]);

      const csvContent = this.arrayToCsv([headers, ...rows]);
      this.downloadCsv(csvContent, "atendimento_por_atendente.csv");
    },
    exportReasonCsv() {
      if (!this.reasonTableItems.length) {
        return;
      }

      const headers = [
        "Motivo",
        "Quantidade",
        "Tempo Médio Espera",
        "Tempo 1ª Resposta",
        "Tempo Médio Atendimento"
      ];

      const rows = this.reasonTableItems.map(item => [
        item.motivo,
        item.quantidade,
        item.tempoMedioEspera,
        item.tempoPrimeiraResposta,
        item.tempoMedioAtendimento
      ]);

      const csvContent = this.arrayToCsv([headers, ...rows]);
      this.downloadCsv(csvContent, "atendimento_por_motivo.csv");
    },
    async getFullService(attendenceId) {
      this.messageList = [];
      await this.$http
        .get(
          `User_Att_Messages_List?Customer_Id=${localStorage.getItem("customer_Id")}&Attendence_Id=${attendenceId}`,
          {
            headers: {
              accept: "*/*",
              Authorization: `bearer ${this.token}`,
            },
          }
        )
        .then((r) => {
          console.log(r.data);
          r.data.forEach(element => {
            if (element.message_Direction == 0) {
              element.message_Direction = "Cliente"
            } else if(element.message_Direction == 1) {
              element.message_Direction = "ChatBot"
            } else if(element.message_Direction == 2) {
              element.message_Direction = "Asesor"
            }
            element.message_Update = this.getLocalDate(element.message_Update)
          })
          this.interacoes = r.data;
          this.dialogInteracoes = true
        })
        .catch((e) => {
          if(e.response.status == 401) {
            this.$store.commit('setDisconnectedByNetworkError', true)
            this.logout()
          }
        })
        .finally(() => {
          //this.loading = false
        });
    },
    normalizeDates() {
      const start = this.startDate || todayISO();
      const end = this.endDate || todayISO();
      return { start, end };
    }, 
    utcMethod(date) {
      let data = new Date(date);
      var dataBase = data.toISOString().replace(/\.\d{3}Z$/, '');

      return dataBase;
    }, 
    getLocalDate(start_Queue) {
      let newDate = new Date(start_Queue + 'Z');
      let valYear = newDate.getFullYear()
      let formatDate = null;
      if(valYear < 2000) {
        formatDate = ""
      } else {
        formatDate =
        [
          newDate.getFullYear(),
          newDate.getMonth()+1,
          newDate.getDate()
        ].join('-') +' ' +
        [newDate.getHours(),
          String(newDate.getMinutes()).padStart(2, '0'),
          String(newDate.getSeconds()).padStart(2, '0')].join(':').toString();
      }

      return formatDate;
    },
    formatDuration(start, end) {
      if (!start || !end) return '00:00:00'

      const startDate = new Date(start)
      const endDate = new Date(end)

      if (isNaN(startDate) || isNaN(endDate)) return '00:00:00'

      let diff = Math.floor((endDate - startDate) / 1000)
      if (diff < 0) diff = 0

      const hours = String(Math.floor(diff / 3600)).padStart(2, '0')
      const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, '0')
      const seconds = String(diff % 60).padStart(2, '0')

      return `${hours}:${minutes}:${seconds}`
    },
    formatPrimeiraResposta(queueStart, start) {
      return this.formatDuration(queueStart, start)
    },
    formatDtHr(value) {
      if (!value) return "";
      const s = String(value).trim();
      const m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})\s+(\d{1,2}):(\d{2}):(\d{2})$/);
      if (m) {
        const [, Y, M, D, h, min, sec] = m;
        return `${String(D).padStart(2, '0')}/${String(M).padStart(2, '0')}/${Y} ${String(h).padStart(2, '0')}:${min}:${sec}`;
      }
      const d = new Date(s);
      if (isNaN(d)) return s;
      const dd = String(d.getDate()).padStart(2, '0');
      const mm = String(d.getMonth() + 1).padStart(2, '0');
      const yyyy = d.getFullYear();
      const hh = String(d.getHours()).padStart(2, '0');
      const mins = String(d.getMinutes()).padStart(2, '0');
      const secs = String(d.getSeconds()).padStart(2, '0');
      return `${dd}/${mm}/${yyyy} ${hh}:${mins}:${secs}`;
    },
    async getAgentAttendances() {
      
      this.servicesStatus = [];
      this.agentsCalls = [];

      const dateStart = this.startDate + "T00:00:00";
      const dateEnd = this.endDate + "T23:59:59";

      console.log("Carregando atendimentos para agente ID:", this.id, "de", dateStart, "até", dateEnd, "e ticketId", this.ticketId);  
      const shouldFilterByAgent = !!this.id && !this.ignoreAgentFilter;
     
      this.ext_opp
        .get(
          `Light_Dashboard_Attendence?customer_id=${localStorage.getItem("customer_Id")}&channel_id=${0}&start_date_time=${this.utcMethod(dateStart)}&end_date_time=${this.utcMethod(dateEnd)}&status_att=0`,
          {
            headers: {
              accept: "*/*",
              Authorization: `bearer ${this.token}`,
            },
          }
        )
        .then((r) => {
          let data = r.data;

          
          if (shouldFilterByAgent ) {
            data = data.filter(item => item.user_Id === this.id.toString());
          }

          data.forEach(element => {
            element.attendence_Start = this.getLocalDate(element.attendence_Start);
            element.attendence_End = this.getLocalDate(element.attendence_End);
            element.attendence_Transfer = this.getLocalDate(element.attendence_Transfer);
            element.attendence_Queue_Start = this.getLocalDate(element.attendence_Queue_Start);
            
            if(element.attendence_Status == 0  && (element.user_Id != null || element.user_Id !== "")){
              console.log("atendimento em atendimento:", element.attendence_Id);
              element.status = "Em atendimento";
            }
            else if(element.attendence_Status == 0 && (element.user_Id == null || element.user_Id === "")){
              console.log("atendimento na fila:", element.attendence_Id);
              element.status = "Na fila";
            }
            else{
              element.status = element.attendence_Result;
            }

            if(element.attendence_Status == 4 && (element.attendence_Start == null || element.attendence_Start === "")){
             
              element.tempoEspera = 
                this.formatDuration(
                  element.attendence_Queue_Start,
                  element.attendence_End
                );  
                
              element.status = "Perdido";
            }
            else{
              element.tempoAtendimento = 
                this.formatDuration(
                  element.attendence_Start,
                  element.attendence_End
                );  

                 element.tempoPrimeiraResposta =
                  this.formatPrimeiraResposta(
                  element.attendence_Queue_Start,
                  element.attendence_Start
                );

                element.tempoEspera = element.tempoPrimeiraResposta;
            }
            
           
           
          });

          this.servicesStatus = data;
          this.agentsCalls = data;
          console.log('Atendimentos carregados:', this.servicesStatus)
        });
    },
    getAttendancesByFilter() {
      console.log("Filtrando atendimentos pelo botão...");
      this.ignoreAgentFilter = true; 
      this.getAgentAttendances();
      this.loadDashboardData();
    },
    async loadDashboardData() {
      await this.$store.dispatch('getPainelAtendimento', {
        customerId: localStorage.getItem("customer_Id"),
        startDate: this.startDate,
        endDate: this.endDate        
      });
      await this.fetchLightDashboard();
    },
    goToHistory(item) {
      this.$router.push({
        name: 'historicoAtendimentos',
        params: {
          id: item.agent_Id
        }
      })
    },    
    exportCsv() {
    if (!this.servicesStatus.length) {
      return;
    }

    const headers = [
      "Ticket",
      "Atendente",
      "Data",
      "Contato",
      "Telefone Contato",
      "Tempo de espera",
      "Tempo de 1º resposta",
      "Tempo de atendimento",
      "Status"
    ];

    const rows = this.servicesStatus.map(item => [
      item.attendence_Id,
      item.agent_Name,
      item.attendence_Queue_Start,
      item.client_Name,
      item.client_Identify,
      item.tempoPrimeiraResposta,
      item.tempoPrimeiraResposta,
      item.tempoAtendimento,
      item.status,
      item.motivo,
      item.submotivo
    ]);

    const csvContent = this.arrayToCsv([headers, ...rows]);
    this.downloadCsv(csvContent, "historico_atendimentos.csv");
    },

    arrayToCsv(data) {
      return data
        .map(row =>
          row
            .map(value => `"${String(value).replace(/"/g, '""')}"`)
            .join(";")
        )
        .join("\n");
    },

    downloadCsv(content, fileName) {
      const blob = new Blob([content], { type: "text/csv;charset=utf-8;" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    forceFileDownloadDialog(response, title) {
      const blob = new Blob([this.arrayToCSVDialog(response)], { type: 'text/csv' });
      const blobURL = window.URL.createObjectURL(blob);

      const link = document.createElement('a')
      link.href = blobURL
      link.setAttribute('download', title)
      document.body.appendChild(link)
      link.click()
      window.URL.revokeObjectURL(blobURL);
    },
    arrayToCSVDialog(dataArray) {
      try{
        if (!Array.isArray(dataArray) || dataArray.length === 0) {
        return '';
      }

      const headers = Object.keys(dataArray[0]);

      const escapeCSV = (value) => {
        if (value === null || value === undefined) return '""';

        let str = String(value);
        
        str = str.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
        str = str.replace(/"/g, '""');

        return `"${str}"`;
      };

      const csvLines = [];

      
      csvLines.push(headers.map(escapeCSV).join(','));

      
      for (const row of dataArray) {
        const line = headers.map(h => escapeCSV(row[h])).join(',');
        csvLines.push(line);
      }

      
      return csvLines.join('\r\n');
      }
      catch(error){
        console.log(error)
    }
  }
  },
  mounted() {
    this.getAgentAttendances();
    this.loadDashboardData();
  },
  watch: {
    async getCurrentCustomer(){
      this.client = this.getCurrentCustomer;
      this.getAgentAttendances();
    },
    initialStartDate(val) {
      this.startDate = val;
    },
    initialEndDate(val) {
      this.endDate = val;
    },
    id() {
      this.getAgentAttendances();
    }
  }

};
</script>

<style scoped>
.filters { display:flex; gap:12px; align-items:center; margin-bottom:12px; width: 100%; flex-wrap:wrap; }
.table { width:100%; border-collapse:collapse; }
.table th, .table td { border:1px solid #ddd; padding:8px; text-align:left; }
.empty { color:#666; padding:8px; }
.filter-container {
   width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.filter-wrapper {
   width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.filter-row {
  display: flex;
   width: 100%;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.menu-datepicker {
  z-index: 3000 !important;
  max-width: none !important; /* 🔥 ISSO RESOLVE */
}

.menu-datepicker .v-picker {
  background-color: #fff;
  overflow: hidden; /* 🔥 evita qualquer bleed visual */
}

.menu-datepicker .v-picker__body {
  width: auto !important;
}

.v-date-picker-header__value button {
  text-transform: capitalize;
}
:deep(.v-date-picker-header__value button) {
  text-transform: capitalize;
}

/* Dashboard Styles */
.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-bottom: 24px;
  padding: auto ;
  box-sizing: border-box;
}

.dashboard-card {
  background: #fff;
  border-radius: 12px;
  padding: 6px 10px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.08);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.kpi-row {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.dashboard-card h3 {
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 6px 0;
  line-height: 1.2;
}

.card-realtime {
  padding: 14px 16px;
}

.card-agents {
  padding: 6px 10px;
}

.card-agents .kpi-row {
  flex-wrap: nowrap;
  gap: 20px;
}

.card-today {
  padding: 8px 12px;
}

.card-realtime .kpi-row,
.card-today .kpi-row {
  gap: 10px;
}

.card-realtime .kpi-item strong,
.card-today .kpi-item strong {
  font-size: 22px;
}

.card-tickets {
  padding: 6px 10px;
}

.kpi-row.center {
  justify-content: center;
}

.kpi-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

.kpi-item strong,
.kpi-status strong {
  font-size: 20px;
  line-height: 1.1;
  margin: 0;
}

.kpi-item.danger strong {
  color: #e53935;
}

.kpi-item.color strong {
  color: #1a73e8;
}

.kpi-item span,
.kpi-status span {
  font-size: 11px;
  line-height: 1.15;
  margin: 2px 0 0;
}

.kpi-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 100px;
}

.dot {
  width: 8px;
  height: 8px;
  margin-bottom: 2px;
}

.green { background: #2ecc71; }
.yellow { background: #f1c40f; }
.gray { background: #9e9e9e; }

@media (max-width: 900px) {
  .dashboard-grid {
    grid-template-columns: 1fr;
  }
}

.search-field {
  max-width: 300px;
}

.tab-content {
  padding: 16px 0;
}

</style>